import { Controller } from "@hotwired/stimulus"

export default class ComponentSearchController extends Controller {
  static targets = ["links", "input", "results", "status"]

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const matches = [...this.linksTarget.content.querySelectorAll("a.nav-link")].filter((link) =>
      link.textContent.toLowerCase().includes(query),
    )
    this.resultsTarget.replaceChildren(
      ...matches.map((link) => {
        const result = document.createElement("a")
        result.className = "list-group-item list-group-item-action"
        result.href = link.href
        result.textContent = link.textContent.replace(/\s+/g, " ").trim()
        return result
      }),
    )
    this.statusTarget.textContent = matches.length
      ? `${matches.length} component demos found.`
      : "No matching demos. Try another component name."
  }

  opened(event) {
    if (document.activeElement === event.target) this.inputTarget.focus()
  }

  prepareForCache() {
    this.inputTarget.value = ""
    this.search()
  }
}
